/**
 * Navigation locale-aware, à utiliser à la place de `next/link` et
 * `next/navigation` pour tout lien **interne**.
 *
 * Sous `localePrefix: 'always'` (état actuel, cf. `routing.ts`) ces helpers sont
 * obligatoires pour tout lien interne : ils portent la locale courante. Un
 * `next/link` nu partirait sur une URL non préfixée, donc un 307 et une
 * navigation dure au lieu d'une transition client.
 *
 * `usePathname` renvoie le pathname **sans** préfixe de locale : les
 * comparaisons du type `pathname === href` (cf. `Navbar`) continuent donc de
 * fonctionner contre des hrefs déclarés sans préfixe.
 *
 * Les liens **externes** (Odys, roadbook, attachments) restent sur `next/link` :
 * ces helpers n'ont rien à y apporter.
 */

import { createNavigation } from 'next-intl/navigation';

import { routing } from './routing';

// Seuls les helpers réellement consommés sont réexportés : `permanentRedirect` et
// `getPathname` viendront avec leur premier usage (SEO / hreflang).
export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
